var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Cookies from "js-cookie";
const getSeconds = (date) => Math.floor(Number(date) / 1000);
export default class AuthClient {
    constructor(api, endpoints, defaultSignInOption = {}) {
        this.defaultSignInOption = {};
        this.refreshServiceState = {
            lastResponse: null,
            lastUpdated: new Date(0, 0),
            refreshPromise: null,
        };
        this.signInUrl = endpoints.signIn;
        this.signOutUrl = endpoints.signOut;
        this.refreshUrl = endpoints.refresh;
        this.defaultSignInOption = defaultSignInOption;
        this.api = api;
    }
    static clearCookies() {
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
    }
    static get isAuth() {
        return Boolean(Cookies.get("accessToken"));
    }
    static get tokens() {
        return {
            refreshToken: Cookies.get("refreshToken"),
            accessToken: Cookies.get("accessToken"),
        };
    }
    resetRefreshServiceState() {
        this.refreshServiceState = {
            lastResponse: null,
            lastUpdated: new Date(0, 0),
            refreshPromise: null,
        };
    }
    signIn(login, password, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const fetchDataOptions = Object.assign(Object.assign({ loginPropName: "email", passwordPropName: "password" }, this.defaultSignInOption), options);
                const response = yield this.api.post(this.signInUrl, {
                    [fetchDataOptions.loginPropName]: login,
                    [fetchDataOptions.passwordPropName]: password,
                });
                Cookies.set("accessToken", response.data.result.accessToken);
                Cookies.set("refreshToken", response.data.result.refreshToken);
                return response;
            }
            catch (error) {
                AuthClient.clearCookies();
                throw error;
            }
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.post(this.signOutUrl);
                AuthClient.clearCookies();
                return response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    refresh() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const refreshToken = Cookies.get("refreshToken");
            if (!this.refreshServiceState.refreshPromise) {
                if (!this.refreshServiceState.lastResponse ||
                    !(((_a = this.refreshServiceState.lastResponse) === null || _a === void 0 ? void 0 : _a.data) &&
                        "errors" in this.refreshServiceState.lastResponse.data)) {
                    if (Math.abs(getSeconds(new Date()) -
                        getSeconds(this.refreshServiceState.lastUpdated)) > 60) {
                        try {
                            this.refreshServiceState.refreshPromise = this.api.post(this.refreshUrl, { refreshToken });
                            const response = yield this.refreshServiceState.refreshPromise;
                            Cookies.set("accessToken", response.data.result.accessToken);
                            Cookies.set("refreshToken", response.data.result.refreshToken);
                            this.refreshServiceState = {
                                lastResponse: response,
                                lastUpdated: new Date(),
                                refreshPromise: null,
                            };
                            return response;
                        }
                        catch (error) {
                            AuthClient.clearCookies();
                            this.refreshServiceState = {
                                lastResponse: error,
                                lastUpdated: new Date(),
                                refreshPromise: null,
                            };
                            throw error;
                        }
                    }
                    else {
                        return this.refreshServiceState
                            .lastResponse;
                    }
                }
                else {
                    AuthClient.clearCookies();
                    throw this.refreshServiceState.lastResponse;
                }
            }
            else
                return this.refreshServiceState.refreshPromise;
        });
    }
}
//# sourceMappingURL=AuthClient.js.map